module.exports = __webpack_public_path__ + "static/media/plusIcon.fe5f49d5.svg";